<template>
    <student-layout>
        <form class="student-login text-center"
              method="post"
              :action="route('student.canvas.login.submit', {uuid: canvas.uuid, ...global_url_params})">

            <h1 class="h5 my-3">Login to your Canvas</h1>

            <div class="card">
                <div class="card-body px-0">
                    <h1>{{ project.name }}</h1>

                    <div class="info">
                        <dl class="theme">
                            <dt>Goal</dt>
                            <dd>{{ theme.name }}</dd>
                        </dl>
                        <dl class="path">
                            <dt>Team</dt>
                            <dd>{{ team.name }}</dd>
                        </dl>
                    </div>

                    <div v-if="login_member" class="loading">
                        <label class="mb-3">Logging you in as</label>
                        <div class="h3">
                            <div class="icon"
                                 :style="{backgroundColor: color( login_member )}">
                                {{ utils.initials( name( login_member ) ) }}
                            </div>
                            {{ name( login_member ) }}
                        </div>

                    </div>
                    <div v-else class="px-3">
                        <p>
                            If you are a member of this team, choose your name.
                        </p>
                        <div v-for="member in members" :key="member.id" class="students">
                            <a href="#" @click.prevent="login(member)" class="student">
                                <span class="icon"
                                      :title="name( member )"
                                      :style="{backgroundColor: color(member)}">
                                    {{ utils.initials( name( member ) ) }}
                                </span>
                                {{ name( member ) }}
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </form>

<!--        <pre>{{ canvas }}</pre>-->

    </student-layout>
</template>

<script>
import StudentLayout from "@/Layouts/StudentLayout";
import utils from "@/mixins/utils";
import themes from "@/DATA/themes";
import API from "@/API";

export default {
    name: "Login",
    components: {StudentLayout},
    props: ['canvas'],
    mixins: [utils],

    data(){
        return {
            form: this.$inertia.form({
                student_id: '',
            })
        }
    },

    computed: {
        project(){
            return this.canvas.project;
        },

        team(){
            return this.canvas.team;
        },

        members(){
            return this.team.members;
        },

        organization(){
            return this.project.organization;
        },
        theme(){
            return themes.reduce((prev, val) => val.id == this.project.theme ? val : prev, {id: 0, name: 'Unknown', slug: 'unknown'});
        },
        login_member(){
            return this.members.reduce((last, now) => (now.id === this.login_member_id ? now : last), null);
        }
    },


    methods: {
        name(member){
            return typeof member.display_name !== 'undefined' ? member.display_name : member.name;
        },

        color(member){
            return typeof member.meta.color !== 'undefined' ? member.meta.color : '#303030';
        },

        login(member){

            this.form.transform(data => ({
                ... data,
                student_id: member.id
            }));

            this.form.post(this.route('student.canvas.login.submit', {uuid: this.canvas.uuid, ...this.global_url_params}), {
                onFinish: () => this.form.reset('student_id'),
            });
        }
    }

}
</script>

<style lang="scss" scoped>
.student-login{
    max-width: 600px;
    margin: 2rem auto;
}
.info{
    display: flex;
    border-top: lighten($dark, 65%) solid 1px;
    border-bottom: lighten($dark, 65%) solid 1px;
    margin: 2rem 0;

    dl{
        padding: 1rem;
        margin-bottom: 0;
        width: 50%;
        flex: 0 0 50%;
    }

    .theme{
        border-right: lighten($dark, 65%) solid 1px;
    }
}
.students{
    margin: auto;
    max-width: 320px;
}
.student{
    display: flex;
    align-items: center;
    margin-bottom: 0.8rem;
    background: rgba($dark, 0.1);
    border-radius: 10rem;
    padding: 0.6rem;
    text-decoration: none;
    color: $dark;

    &:hover{
        background: $dark;
        color: $light;
    }

    .icon{
        display: flex;
        width: 2rem;
        height: 2rem;
        flex: 0 0 2rem;
        align-items: center;
        justify-content: center;
        margin-right: 0.4rem;
        border-radius: 50%;
        color: $light;
    }
}
.loading{
    font-size: 1.2rem;
    margin: 2rem 0;
    vertical-align: middle;

    .icon{
        display: inline-flex;
        width: 3rem;
        height: 3rem;
        align-items: center;
        justify-content: center;
        margin-right: 0.4rem;
        border-radius: 50%;
        color: $light;
    }
}
</style>
